import React from 'react';
import './Contactus.css';
import {
    MapPin,
    Phone,
    Mail,
    Linkedin,
    Twitter,
    Facebook,
    Instagram
  } from 'lucide-react';
  
const Contactus = () => {
  return (
    <div className="mainHome-container">
    
    <section className="contact-quote-section">
      <div className="contact-left">
        <h2>Contact Us</h2>
        <p >
          Have questions about our products or services? Get in touch with our team for more
          information.
        </p>

        <div className="contact-info">
          <div className="info-block">
            <MapPin className="icon" />


            <div style={{textAlign:"left"}}>
              <strong>Our Address</strong>
              <p >Flat No.: 304, Block No.: 22,
Raintree Park Malayasian Township,
5th Phase KPHB,
VTC: Kukatpally, PO: Kukatpally
District: Medchal-Malkajgiri,
Telangana - 500072</p>
            </div>
          </div>

          <div className="info-block">
            <Phone className="icon" />

            <div style={{textAlign:"left"}}>
              <strong>Phone</strong>
              <p><a style={{textDecoration:"none",color:'inherit'}} href="tel:+919959941212">+91 9959941212</a></p>
            </div>
          </div>

          <div className="info-block">
            <Mail className="icon" />
            <div style={{textAlign:"left"}}>
              <strong>Email</strong>
              <p>psindhurareddy@pkrvedaglobal.com</p>
            </div>
          </div>
        </div>

        
        
      </div>

      <div className="contact-right">
        
        <form className="quote-form">
            <h2>Write to Us</h2>
          <div className="input-row">
            <input type="text" placeholder="Your full name" required />
            <input type="text" placeholder="Your company name" required />
          </div>

          <div className="input-row">
            <input type="email" placeholder="Your email address" required />
            <input type="tel" placeholder="Your phone number" required />
          </div>

          <div className="input-row">
            <input type="email" placeholder="Email Id" required />
            <input type="email" placeholder="Your Email Id" required />
          </div>

          <select required>
            <option value="">Select a product category</option>
            <option value="metal">Metal Scrap</option>
            <option value="agri">Agricultural Product</option>
            <option value="medical">Medical Equipment</option>
          </select>

          <textarea rows="5" placeholder="Tell us about your requirements" required></textarea>

          <button type="submit">Submit Request</button>
        </form>
      </div>
    </section>
    
    </div>
  );
};

export default Contactus;

